export default __webpack_public_path__ + "static/media/STL_20th AGM_Transcription.bc0a1f08.pdf";